import React, { useEffect, useState } from "react";
import { StaticRoutes } from "../routes";
import { useNavigate } from "react-router-dom";
import styles from "./Bidding.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import BiddingLogo from "../../assets/BidProPlusBiddingLogo.png";
import TabBar from "../../components/TabBar/TabBar";
import CorporateTab from "../../components/CorporateTab/CorporateTab";
import AirlinesSelect from "../../components/AirlinesSelect/AirlinesSelect";
import AlaskaTab from "../../components/AlaskaTab/AlaskaTab";
import UPSTab from "../../components/UPSTab/UPSTab";

const Bidding = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  useEffect(() => {
    setAnimate(true);
  }, []);

  const options = [
    {
      label: "UPS",
      children: (
        <div>
          <UPSTab />
        </div>
      ),
    },
    {
      label: "Alaska",
      children: (
        <div>
          <AlaskaTab />
        </div>
      ),
    },
  ];

  const tabs = [
    { label: "Airlines", child: <AirlinesSelect options={options} /> },
    { label: "Corporate", child: <CorporateTab /> },
  ];

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div className={styles.pageContainer}>
        <div className={styles.logoContainer}>
          <img
            className={styles.logo}
            src={BiddingLogo}
            alt="BidPro Plus! Bidding Logo"
          />
        </div>
        <div className={`${styles.pageBody} ${animate ? styles.slideIn : ""}`}>
          <TabBar tabs={tabs} />
        </div>
      </div>
      <Footer lists={footerLists} inverse={true} />
    </>
  );
};

export default Bidding;
